var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallLayerThree(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 240 241",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 152.645L0 184.79L120 240.5L240 184.79L170.77 152.645L120 176.21L69.23 152.645Z",
    fill: "#45DAF6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M170.77 88.3546L120 111.93L69.23 88.3546L0 120.5L69.23 152.645L120 129.07L170.77 152.645L240 120.5L170.77 88.3546Z",
    fill: "#464B55"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M170.77 88.3549L240 56.2098L120 0.499878L0 56.2098L69.23 88.3549L120 64.7798L170.77 88.3549Z",
    fill: "#464B55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M69.23 152.645L120 176.21L170.77 152.645L120 129.07L69.23 152.645Z",
    fill: "#578BFA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M69.2122 88.3598L119.982 111.925L170.752 88.3598L119.982 64.7847L69.2122 88.3598Z",
    fill: "#578BFA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallLayerThree);
export default __webpack_public_path__ + "static/media/SmallLayerThree.4df82601bbc4bfbef6c27a06cff069b0.svg";
export { ForwardRef as ReactComponent };